export enum TargetTypes {
  FINANCE = 'finance',
  INSURANCE = 'insurance',
}
